import React from "react";
import { useForm, Controller } from "react-hook-form";

import { Form, Dropdown } from "react-bootstrap";

import school from "../../../../../image/purchase/school.png";
import { StyledWrapper, StyledSelectCompany } from "./styledCompanyCards";

const CompanyCardsComponent = ({
  data,
  selectedCompany,
  handleDeleteModal,
  handleEditModal,
  register
}) => {

  return (
    <StyledWrapper className="w-100 m-0">
      <Form.Check
        type="radio"
        name="select-company"
        value={data.id}
        className="hidden-radio"
          {...register}
      />
      <StyledSelectCompany
        className={`d-flex flex-column justify-content-center align-items-center ${
          selectedCompany == data.id ? "selected-company" : ""
        }`}
      >
        <Dropdown className="drop-down position-absolute">
          <Dropdown.Toggle
            id="dropdown-basic"
            className="dropdown-toggle p-0 pt-1 p-md-0 bg-transparent border-0"
          >
            <i>&#8230;</i>
          </Dropdown.Toggle>
          <Dropdown.Menu className="p-2">
            <Dropdown.Item
              className="text-end p-0"
              id={data.id}
              onClick={handleEditModal}
            >
              ویرایش
            </Dropdown.Item>
            <Dropdown.Item
              className="text-end p-0 pt-2"
              id={data.id}
              name={data.name}
              onClick={handleDeleteModal}
            >
              حذف
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <img
          src={school}
          alt="سازمان های تعریف شده"
          className="mb-1 mt-2"
          style={{ maxWidth: "100px" }}
        />
        <p className="m-1 text-center">{data.name}</p>
      </StyledSelectCompany>
    </StyledWrapper>
  );
};

export default CompanyCardsComponent;
